<template>
  <div>
    <customList :filterItems="formItems" :filterModel="filter"  @selectChange="selectChange" :columns="columns" :listUrl="'/admin/userList'" ref="customList"></customList>
    <Modal
      title="用户信息"
      v-model="settleModalstatus"
      :mask-closable="false"
      :width="500"
      @on-cancel="closeSettleModal"
    >
      <div>
        <CustomForm :title="''" :dataArr="createObjArr" :model="createObj" :defaultSpan="24" :labelWidth="100"/>
      </div>
      <div slot="footer">
        <Button @click="closeSettleModal">取消</Button>
        <Button type="primary" @click="submitSettle">更新</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { getDataFromConfig } from '../../../assets/js/share';
const createObjArr = [
  {
    label: '姓名',
    key: 'name'
  },
  {
    label: '使用平台',
    key: 'apiType',
    type: 'select',
    options: [
      { name: 'minimax', value: 1 },
      { name: 'OpenAI', value: 2 },
      { name: 'Claude', value: 3 }
    ],
    verify: [
      {
        required: true,
        trigger: 'change'
      }
    ]
  },
  // {
  //   label: '是否可用',
  //   key: 'delStatus',
  //   type: 'radio',
  //   options: [
  //     { name: '可用', value: 1 },
  //     { name: '禁用', value: 2 }
  //   ]
  // },
  {
    label: '管理员',
    key: 'userType',
    type: 'select',
    options: [
      { name: '普通成员', value: 1 },
      { name: '后台管理员', value: 2 },
      { name: '渠道自切换', value: 3 }
    ]
  },
  {
    label: 'AI通道切换',
    key: 'checkApi',
    type: 'select',
    options: [
      { name: '不可切换', value: 1 },
      { name: '可自行切换', value: 2 }
    ]
  }
];
const createObj = getDataFromConfig(createObjArr); // 通过getDataFromConfig方法推导出模型对象
export default {
  name: 'userList',
  data () {
    return {
      settleModalstatus: false,
      createObj,
      createObjArr,
      formItems: [
        { label: '姓名', model: 'name' },
        { type: 'select', label: '使用平台', model: 'apiType', options: [{ name: '全部', value: '' }, { name: 'minimax', value: 1 }, { name: 'OpenAI', value: 2 }, { name: 'Claude', value: 3 }, { name: '讯飞星火', value: 4 }], fun: 'selectChange' },
        { type: 'select', label: '是否可切换平台', model: 'checkApi', options: [{ name: '全部', value: '' }, { name: '不可切换', value: 1 }, { name: '可以切换', value: 2 }], fun: 'selectChange' },
        { type: 'select', label: '状态', model: 'delStatus', options: [{ name: '全部', value: '' }, { name: '可用', value: 0 }, { name: '禁用', value: 1 }], fun: 'selectChange' },
        { type: 'select', label: '管理员', model: 'userType', options: [{ name: '全部', value: '' }, { name: '后台管理员', value: 2 }, { name: '普通成员', value: 1 }, { name: '渠道自切换', value: 3 }], fun: 'selectChange' },
        { type: 'button', buttonArr: [{ message: '查询', type: 'primary', fun: 'selectChange' }] }
      ],
      filter: {
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        { title: '姓名', key: 'name', ellipsis: true, tooltip: true, fixed: 'left' },
        {
          title: '使用平台',
          key: 'api_type',
          width: 100,
          render: (h, params) => {
            return h('div', [
              h('span', {}, params.row.api_type === 1 ? 'minimax' : params.row.api_type === 2 ? 'OpenAI' : params.row.api_type === 3 ? 'Claude' : params.row.api_type === 4 ? '科大讯飞' : '')
            ]);
          }
        },
        {
          title: '可切换平台',
          key: 'check_api',
          width: 100,
          render: (h, params) => {
            return h('div', [
              h('span', {}, params.row.check_api === 1 ? '否' : params.row.check_api === 2 ? '是' : '')
            ]);
          }
        },
        {
          title: '用户状态',
          key: 'del_status',
          width: 80,
          render: (h, params) => {
            return h('div', [
              h('span', {}, params.row.del_status === 0 ? '可用' : params.row.del_status === 1 ? '禁用' : '')
            ]);
          }
        },
        {
          title: '管理员',
          key: 'user_type',
          width: 80,
          render: (h, params) => {
            return h('div', [
              h('span', {}, params.row.user_type === 1 ? '普通成员' : params.row.user_type === 2 ? '后台管理员' : params.row.user_type === 3 ? '渠道自切换' : '')
            ]);
          }
        },
        {
          title: '创建时间',
          key: 'create_time',
          width: 150,
          render: (h, params) => {
            const dbDatetime = new Date(params.row.create_time);
            return h('div', [
              h('span', {}, params.row.create_time ? dbDatetime.toLocaleString() : '')
            ]);
          }
        },
        {
          title: '更新时间',
          key: 'update_time',
          width: 150,
          render: (h, params) => {
            const dbDatetime = new Date(params.row.update_time);
            return h('div', [
              h('span', {}, params.row.update_time ? dbDatetime.toLocaleString() : '')
            ]);
          }
        },
        {
          title: '操作',
          key: 'groupName',
          width: 110,
          fixed: 'right',
          render: (h, params) => {
            const buttonArr = [];
            buttonArr.push(
              h(
                'Button',
                {
                  props: { type: 'info', size: 'small' },
                  on: {
                    click: () => {
                      const obj = {
                        userId: params.row.user_id,
                        name: params.row.name,
                        apiType: params.row.api_type,
                        delStatus: params.row.del_status,
                        userType: params.row.user_type,
                        checkApi: params.row.check_api
                      };
                      this.createObj = Object.assign({}, obj);
                      this.settleModalstatus = true;
                    }
                  }
                },
                '修改信息'
              )
            );
            return h('div', { }, buttonArr);
          }
        }
      ]
    };
  },
  methods: {
    selectChange () {
      alert('开始查找');
    },
    closeSettleModal () {
      this.settleModalstatus = false;
    },
    submitSettle () {
      const { userId, apiType, userType, checkApi } = this.createObj;
      const params = {
        userId,
        apiType,
        userType,
        checkApi
      };
      const url = '/admin/updateUser';
      this.$ajax.post(url, { params }).then((data) => {
        if (data.data && data.data.status === 200) {
          this.$Message.success('修改成功');
          this.$refs.customList.searchTableInfo();
        } else {
          this.$Message.error(data.data.msg || '修改失败');
        }
        this.settleModalstatus = false;
      }).catch(() => {
        this.$Message.error('修改失败');
      });
    }
  },
  mounted () {
    this.columns.forEach((item) => {
      this.$set(item, 'align', 'center');
    });
  }
};
</script>
<style scoped>
</style>
